import React from 'react';
import Link from 'src/components/Link';
import routes from 'src/constants/routes';
import styles from './styles.module.scss';

const PublicMenu: React.FC = () => (
  <nav>
    <ul className={styles['link-list']}>
      <li className={styles['link-item']}>
        <Link to={routes.about} className={styles['link']}>
          О компании
        </Link>
      </li>
      <li className={styles['link-item']}>
        <Link to={routes.contacts} className={styles['link']}>
          Контакты
        </Link>
      </li>
    </ul>
  </nav>
);

export default PublicMenu;
